import React, { useEffect, useRef, useState } from "react";
import { Button, Form } from "reactstrap";
import { Link } from "react-router-dom";
import "../../assets/css/common.css";
import Logo from "../../components/Logo";
import { confirmEmailAPI, resendConfirmationAPI } from "../../API/userApi";

/**
 * Where the sign-up confirmation link lands: /verify-email#token=...
 *
 * The token is in the fragment, so it never reaches the hosting server. It is
 * read once, removed from the address bar, and sent to be confirmed.
 */
const readTokenFromUrl = () => {
  const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
  return params.get("token") || "";
};

const VerifyEmail = () => {
  const [token] = useState(readTokenFromUrl);
  const [state, setState] = useState(token ? "confirming" : "missing");
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [resendNote, setResendNote] = useState(null);
  const started = useRef(false);

  useEffect(() => {
    if (window.location.hash) {
      window.history.replaceState(null, "", window.location.pathname);
    }
    // The link works once, so make sure it is only ever sent once.
    if (!token || started.current) return;
    started.current = true;
    confirmEmailAPI(token)
      .then((result) => {
        setMessage(result?.message || "Your email address is confirmed.");
        setState("confirmed");
      })
      .catch((error) => {
        setMessage(error?.response?.data?.message || "Could not confirm the email address. Please try again.");
        setState("failed");
      });
  }, [token]);

  const resend = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    try {
      const result = await resendConfirmationAPI(email.trim());
      setResendNote(result?.message || "We have emailed you a new link.");
    } catch (error) {
      setResendNote(error?.response?.data?.message || "Could not send the email. Please try again.");
    }
  };

  return (
    <div className="row signup_mobile_container full_view_container">
      <div className="col-xl-5 col-lg-5 col-md-5 hide_img">
        <div className="reset_banner_img" />
      </div>
      <div className="col-xl-7 col-lg-7 col-md-7 col-sm-12">
        <div className="padding_left_signup ">
          <div style={{ marginTop: 70 }}>
            <Logo />
          </div>
          <h4 className="heading" style={{ marginTop: 50 }}>
            Confirm your email address
          </h4>

          {state === "confirming" && (
            <p className="status-message" role="status">Confirming...</p>
          )}

          {state === "confirmed" && (
            <>
              <p className="status-message" role="status">{message}</p>
              <Link to="/">Go to sign in</Link>
            </>
          )}

          {(state === "failed" || state === "missing") && (
            <>
              <p className="status-message" role="alert">
                {state === "missing"
                  ? "This page needs the link from your confirmation email."
                  : message}{" "}
                Enter your email to get a new link.
              </p>
              {resendNote ? (
                <p className="status-message" role="status">{resendNote}</p>
              ) : (
                <Form onSubmit={resend}>
                  <div className="reset_input_div">
                    <input
                      className="reset_input_field"
                      type="email"
                      name="email"
                      autoComplete="email"
                      placeholder="Enter Your Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <Button type="submit" className="submit_btn" style={{ marginTop: 20 }}>
                    Send a new link
                  </Button>
                </Form>
              )}
              <p style={{ marginTop: 20 }}><Link to="/">Back to sign in</Link></p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
